import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { TooltipModule } from "ngx-bootstrap/tooltip";


@Component({
    selector: "ch-tag",
    templateUrl: "./tag.component.html",
    styleUrls: ["./tag.component.scss"],
    imports: [TooltipModule]
})
export class TagComponent implements OnInit {
  @Input() name: string;
  @Input() color: string;
  @Output() remove = new EventEmitter();
  @Input() canRemove: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  removeTag() {
    this.remove.emit("");
  }
}
